// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brickWrapper--1co6xbW4 {\n  display: grid;\n  grid-gap: 5px 15px;\n  padding: 0 15px;\n}\n  .brickWrapper--1co6xbW4 .itemWrapper--26ldX4xO {\n    min-width: 0;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brickWrapper": "brickWrapper--1co6xbW4",
	"itemWrapper": "itemWrapper--26ldX4xO"
};
export default ___CSS_LOADER_EXPORT___;
